module.exports = __webpack_public_path__ + "static/media/26.facd81d1.svg";